import Link from "next/link"
import { Flex, Icon, List, ListItem, useDisclosure } from "@chakra-ui/react"
import { FiChevronDown, FiChevronUp, FiChevronRight } from "react-icons/fi"
import useWindowDimensions from "hooks/useWindowDimensions"
import MegaMenu from "components/nav/megaMenu"

export default function MenuItem({
    className = "",
    item,
    level,
    isFirst,
    isLast,
    doAction,
    isMobile = false,
    mobileMenuToggle,
}) {
    const { open, onToggle, onOpen, onClose } = useDisclosure({ defaultIsOpen: false })
    const { height = 0 } = useWindowDimensions()

    const linkHref = (() => {
        switch (item.typeHandle) {
            case "htmlPage":
                return "/" + item.page[0]?.slug

            case "path":
                return item.navigationPath ? "/" + item.navigationPath.replace(/^\//, "") : "/"

            case "link":
                return item.string

            default:
                return null
        }
    })()

    function onClick(e) {
        if (item.menuItemHandler) {
            e.preventDefault()
            doAction(item.menuItemHandler)
        } else if (isMobile && item.pages?.length > 0) {
            e.preventDefault()
            onToggle()
        } else {
            mobileMenuToggle && mobileMenuToggle()
        }
    }

    const isSubhead = item.typeHandle === "subhead"

    const shouldUseLink = linkHref && !isSubhead

    const target = item.typeHandle === "link" || item.openInNewTab ? "_blank" : null

    const cursorStyle = ["null", "subhead"].includes(item.typeHandle) ? "default" : "pointer"

    const hoverStyles = item.highlight
        ? {
              bgColor: "color4",
              color: "#fff",
          }
        : isMobile
          ? item.grayscale
              ? { bgColor: "rgba(220,220,220)" }
              : { bgColor: "rgba(0,0,0,0.1)" }
          : { color: "color4" }

    const anchorPadding =
        level === 0
            ? isMobile
                ? "10px 20px"
                : "20px 30px"
            : isMobile
              ? `10px 20px 10px ${20 + level * 10}px`
              : "5px 15px"

    const borderLeft = level === 0 ? (isMobile ? "none" : "1px solid white") : "none"

    let buttonStyles = {}
    if (item.grayscale) {
        buttonStyles.color = "#323232"
        buttonStyles.bg = "#e7e7e7"
    } else if (item.highlight) {
        buttonStyles.color = "#fff"
        buttonStyles.bg = "color1"
    } else if (isSubhead) {
        buttonStyles.color = "color4"
        buttonStyles.bg = null
    }

    return (
        <ListItem
            display="block"
            // position="relative"
            onMouseOver={isMobile ? undefined : onOpen}
            onMouseOut={isMobile ? undefined : onClose}
            borderLeft={borderLeft}
            bg={item.bgColor || "transparent"}
            className={
                "menu__item " + className + (item.highlight ? "highlight " : " ") + (item.class ? item.class : "")
            }
        >
            <Flex
                className={isSubhead ? "menu-subhead" : null}
                as={shouldUseLink ? Link : "a"}
                href={shouldUseLink ? linkHref : undefined}
                target={target}
                justify="space-between"
                cursor={cursorStyle}
                onClick={onClick}
                h={isMobile ? "unset" : level > 0 ? "auto" : "header.h"}
                p={anchorPadding}
                mt={isSubhead || isFirst ? "15px" : 0}
                // mb={isMobile ? "1px" : 0 }
                align="center"
                // position="relative"
                textTransform={isSubhead || level === 0 ? "uppercase" : "normal"}
                fontSize={isSubhead ? "12px" : "13px"}
                lineHeight={isSubhead ? "14px" : "15px"}
                fontWeight={isSubhead ? "700" : "normal"}
                textAlign="left"
                whiteSpace={level === 0 ? "nowrap" : "unset"}
                color={buttonStyles.color}
                bgColor={buttonStyles.bg}
                _hover={hoverStyles}
                css={item.styles}
            >
                {item.label || item.title}
                {item.pages?.length ? (
                    <Icon
                        display={level < 1 ? (isMobile ? "inline" : "none") : "inline"}
                        as={isMobile ? (open ? FiChevronUp : FiChevronDown) : FiChevronRight}
                        m="3px 0 0 5px"
                        w="16px"
                        h="16px"
                    />
                ) : null}
            </Flex>
            {item.pages?.length ? (
                item.submenuType === "megaMenu" ? (
                    <MegaMenu
                        item={item}
                        level={level}
                        isFirst={isFirst}
                        isLast={isLast}
                        doAction={doAction}
                        isMobile={isMobile}
                        mobileMenuToggle={mobileMenuToggle}
                        open={open}
                    />
                ) : (
                    <List.Root
                        className="menu"
                        bg={item.bgColor || "color2"}
                        minW={270}
                        zIndex={1000}
                        display={open ? "block" : "none"}
                        position={isMobile ? "unset" : "absolute"}
                        top={isMobile ? 0 : level < 1 ? "99%" : "-15px"}
                        left={isMobile || level < 1 ? "unset" : "100%"}
                        right={isLast ? 0 : "unset"}
                        pb={4}
                        borderTop={isMobile ? "none" : level === 0 ? "1px solid white" : "none"}
                        borderTopColor="#fff"
                        maxHeight={height < 810 ? height - 175 + "px" : "none"}
                        overflowY={"scroll"}
                    >
                        {item.pages.map((subitem, i) => {
                            return (
                                <MenuItem
                                    key={i}
                                    item={subitem}
                                    level={level + 1}
                                    isFirst={i === 0}
                                    isLast={item.pages.length === i + 1}
                                    doAction={doAction}
                                    isMobile={isMobile}
                                    mobileMenuToggle={mobileMenuToggle}
                                />
                            )
                        })}
                    </List.Root>
                )
            ) : null}
        </ListItem>
    )
}
